import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
    bodyFontFamily,
    bodyFontWeight,
    bodyFontSize,
    bodyLineHeight,
    bodyLetterSpacing,
} from 'common/styles/typography';

const withBodyStyles = (StyledComponent) =>
    styled(StyledComponent)`
        font-family: ${bodyFontFamily};
        font-weight: ${({ fontWeight }) => fontWeight || bodyFontWeight};
        font-size: ${bodyFontSize};
        line-height: ${({ lineHeight }) => lineHeight || bodyLineHeight};
        letter-spacing: ${bodyLetterSpacing};
    `;

// These are separated to avoid defining the components in the render
const bodyStyledComponents = {
    span: withBodyStyles(styled.span``),
    p: withBodyStyles(styled.p``),
    label: withBodyStyles(styled.label``),
};

export const Body = ({ tag, lineHeight, fontWeight, ...props }) => {
    const StyledComponent = bodyStyledComponents[tag];

    return <StyledComponent lineHeight={lineHeight} fontWeight={fontWeight} {...props} />;
};

Body.propTypes = {
    tag: PropTypes.oneOf(Object.keys(bodyStyledComponents)),
    lineHeight: PropTypes.string,
    fontWeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Body.defaultProps = {
    tag: 'p',
    lineHeight: null,
    fontWeight: null,
};
